import React from "react";
import { Link } from "react-router-dom";
import notFoundImg from "../img/404_no_bg_small.png";


const NotFound = () => {
    return (
        <div className="container text-center" style={{ marginTop: '50px' }}>
            {/*<h1 style={{ fontSize: '72px', fontWeight: 'bold' }}>404</h1>*/}
            <img src={notFoundImg} alt="404" className="img-fluid"/>
            {/*<h2>Page Not Found</h2>*/}
            <p className="text-muted">
                Sorry, the page you are looking for does not exist.
            </p>
            <Link to="/" className="btn btn-primary mt-3">
                Go Home
            </Link>
        </div>
    );
};

export default NotFound;
